module.exports = __webpack_public_path__ + "img/location-choose.1c9dfe6d.png";